export enum FilterTerms {
    Both = 'Both',
    Practitioner = 'Practitioner',
    Facility = 'Facility',
    SpecialtyAndService = 'SpecialtyAndService',
    people = 'people',
    places = 'places',
    peopleplaces = 'peopleplaces',
    acceptingNewPatients = 'acceptingNewPatients',
    opentime = 'opentime',
    eveningHours = 'eveningHours',
    weekendHours = 'weekendHours',
    telehealth = 'telehealth',
    handicapAccess = 'handicapAccess',
    accreditedFacility = 'accreditedFacility',
    gender = 'gender',
    language = 'language',
    hospitalPrivilege = 'hospitalPrivilege',
    subProductKey = 'subProductKey',
    // lgbtqia = 'lgbtqia',
    sortType = 'sortType',
    onlineScheduling = 'onlineScheduling'
}

export enum DisplayFilterTerms {
    sortType = 'Sort By',
    telehealth = 'Virtual Visits',
    peopleplaces = 'People and Places',
    acceptingNewPatients = 'Accepting New Patients',
    opentime = 'Open Time',
    eveningHours = 'Open Evenings',
    weekendHours = 'Open Weekends',
    handicapAccess = 'Wheelchair Accessible',
    accreditedFacility = 'Accredited Facility',
    gender = 'Gender',
    language = 'Spoken Language',
    hospitalPrivilege = 'Hospital Privilege',
    subProductKey = 'Network Accepted',
    networksAccepted = 'Networks Accepted',
    // lgbtqia = 'LGBTQIA+ Affirming',
    BestMatch = 'Best Match',
    Distance = 'Distance',
    NameMatch = 'Name Match',
    people = 'People',
    places = 'Places',
    onlineScheduling = 'Online Scheduling'
}

export enum FilterTypes {
    dropdown = 'dropdown',
    checkbox = 'checkbox',
    checkboxlist = 'checkbox-list'
}

export enum CareTypeTerms {
    Medical = 'Medical',
    BehavioralHealth = 'Behavioral Health',
    Dental = 'Dental',
    Vision = 'Vision',
    HomeCommunity = 'Home & Community-Based Services',
    Pharmacy = 'Pharmacy',
    Medication = 'Medication'
}

export enum SortTypes {
    BestMatch = 'BestMatch',
    Distance = 'Distance',
    NameMatch = 'NameMatch'
}

export enum SearchOptionTypes {
    providerName = 'providerName',
    specialty = 'specialty',
    phoneNumber = 'phoneNumber'
}

export enum ProviderTypes {
    pcp = 'Primary Care Provider (PCP)'
}

export enum SpecialtyTypes {
    ProviderType = 'ProviderType',
    Service = 'Service'
}